import { isE164 } from "./wire-number.js";
export const DESTINATION_REFUSAL_RULE = [
    "not_e164",
    "country_not_allowed",
    "country_unreviewed",
    "emergency_or_short",
    "premium_rate",
];
function refused(rule) {
    return Object.freeze({ allowed: false, rule });
}
/** The one reviewed country whose calling code `e164` starts with, or `null`. */
function reviewedCountryOf(e164, prefix) {
    const matching = Object.entries(prefix).filter(([, entry]) => e164.startsWith(`+${entry.callingCode}`));
    // Two reviewed countries sharing a calling code (the NANP, say) would need a per-country range to
    // tell them apart; until an entry carries one, a shared code is refused rather than guessed.
    const [only] = matching;
    if (matching.length !== 1 || only === undefined)
        return null;
    const [country, entry] = only;
    return { country, entry };
}
function startsWithAny(nsn, prefixes) {
    return prefixes.some((each) => nsn.startsWith(each.prefix));
}
/**
 * `allowedCountry` is the trunk's `allowed_destination_country`; `prefix` is normally
 * `REVIEWED_DESTINATION_PREFIX`. A listed country with no entry in `prefix` allows nothing.
 */
export function destinationVerdict(e164, allowedCountry, prefix) {
    if (!isE164(e164))
        return refused("not_e164");
    const reviewed = reviewedCountryOf(e164, prefix);
    if (reviewed === null)
        return refused("country_unreviewed");
    const { country, entry } = reviewed;
    if (!allowedCountry.includes(country))
        return refused("country_not_allowed");
    const nsn = e164.slice(1 + entry.callingCode.length);
    if (startsWithAny(nsn, entry.emergency))
        return refused("emergency_or_short");
    if (startsWithAny(nsn, entry.premiumRate))
        return refused("premium_rate");
    if (startsWithAny(nsn, entry.shortCode))
        return refused("emergency_or_short");
    if (nsn.length < entry.nationalSignificantLength)
        return refused("emergency_or_short");
    if (nsn.length > entry.nationalSignificantLength)
        return refused("not_e164");
    return Object.freeze({ allowed: true, country });
}
//# sourceMappingURL=destination.js.map